import BaseTable, { ColumnType } from "../../../components/elements/BaseTable"
import { Tour, TourObjectTask } from "../types"
import TourTableRow from "./TourTableRow"

type TourTableType = {
    tours: Tour[]
    tasksByObject: Map<string, TourObjectTask[]>
    deleteTour: (id: string) => void
}

export default function TourTable(props: TourTableType) {
    const columns: ColumnType[] = [
        { label: "Tour" },
        { label: "Mitarbeiter" },
        { label: "Objekte" },
        { label: "Aufgaben" },
        { label: "Wochenplan", responsive: "hidden lg:table-cell" },
        { label: "Status" },
        { label: "" },
    ]

    return (
        <BaseTable
            columns={columns}
            tbody={props.tours.map((tour) => (
                <TourTableRow key={tour._id} tour={tour} tasksByObject={props.tasksByObject} deleteTour={props.deleteTour} />
            ))}
        />
    )
}
